import "./locations.js";
import "./locations.less";


// WEBPACK FOOTER //
// ./src/pages/locations/index.js